import React from "react";

const Button = ({
  backgroundColor,
  textColor,
  width,
  fontSize,
  fontFamily,
  borderRadius,
  fontWeight,
  padding,
  border,
  margin,
  children,
  onClick,
  btnText,
  type = "button",
    disabled = false
}) => {
  const buttonStyle = {
    backgroundColor,
    color: textColor,
    width,
    fontSize,
    btnText,
    fontFamily,
    padding,
    margin,
    borderRadius,
    border,
    fontWeight,
    onClick,
  };

  return (
      <button
          disabled={disabled}
        type={type}
        onClick={onClick}
        className="flex  items-center gap-2 justify-center w-full  font-poppins"
        style={buttonStyle}
      >
        {btnText}
      </button>
  );
};

export default Button;
